import { Box, Stack, Tooltip, Typography } from '@mui/material';
import { DayName } from 'generated/graphql';
import { toTitleCase } from 'v2/utils/strings';
import { DayButton } from './OutboundCardFrequencyDayButton';
import { DAYS } from './constants';

interface OutboundCardWeeklyProps {
  selectedDay?: DayName;
  toggleWeeklyFrequencyDayStatus: (day: DayName) => void;
}

export const OutboundCardWeekly = ({
  selectedDay,
  toggleWeeklyFrequencyDayStatus,
}: OutboundCardWeeklyProps) => {
  return (
    <Stack spacing={1} mt={1}>
      <Box>
        <Typography variant="caption" color="text.secondary">
          Repeat on every
        </Typography>
      </Box>
      <Stack spacing={0.5} direction="row">
        {DAYS.map((item) => {
          return (
            <Tooltip
              key={item.day}
              title={toTitleCase(item.day)}
              placement="bottom"
            >
              <DayButton
                selected={item.day === selectedDay}
                onClick={() => toggleWeeklyFrequencyDayStatus(item.day)}
              >
                {item.label}
              </DayButton>
            </Tooltip>
          );
        })}
      </Stack>
    </Stack>
  );
};
